import { Flex, Form, Typography } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { CompanyForm } from "components";
import { createCompany } from "services";
import { routes } from "constants/routes";
import { COMPANY_TYPES, CreateCompanyRequest, NOTIFICATION_TYPE_ENUM } from "interfaces";
import { useNotificationContext } from "providers";
import { dateISOFormat, getPhoneMaskValue, parseErrorMessage } from "utils";
import { SAFE_DEAL } from "utils/envConstants";
import dayjs from "dayjs";

export const CompanyCreatePage = () => {
  const { openNotification } = useNotificationContext();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const closeResultModal = () => {
    return Promise.resolve(navigate(`/${routes.companies}`));
  };

  const saveCompany = async () => {
    setLoading(true);
    const values = form.getFieldsValue();

    const dataToSend: CreateCompanyRequest = {
      ...values,
      phone: getPhoneMaskValue(values.phone) || undefined,

      contractDate: values.contractDate ? dateISOFormat(values.contractDate) : undefined,
      contractNumber: values.contractNumber ? values.contractNumber : undefined,
      email: values.email ? values.email : undefined,
      isOnlyTaxResidentRF: values.isOnlyTaxResidentRF ? values.isOnlyTaxResidentRF : false,
      isControlPersonsRF:
        values.type === COMPANY_TYPES.COMPANY
          ? values.isControlPersonsRF
            ? values.isControlPersonsRF
            : false
          : undefined,
      isForeignOrg:
        values.type === COMPANY_TYPES.COMPANY ? (values.isForeignOrg ? values.isForeignOrg : false) : undefined,
      bankAccountRequest: values.bankAccountRequest
        ? {
            accountName: values.bankAccountRequest.bankName,
            ...values.bankAccountRequest,
          }
        : undefined,
      birthDate: values.birthDate ? dayjs(values.birthDate).format("YYYY-MM-DD") : undefined,
      identificationDocIssueDate: values.identificationDocIssueDate
        ? dayjs(values.identificationDocIssueDate).format("YYYY-MM-DD")
        : undefined,
      postAddress: values.postAddress ? values.postAddress : undefined,
      patronymic: values.patronymic ? values.patronymic : undefined,
    };

    await createCompany({ ...dataToSend, isResident: values.type === COMPANY_TYPES.IP ? true : values.isResident })
      .then((id) => {
        openNotification({
          message: "Компания успешно добавлена",
          type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        });
        setTimeout(() => {
          navigate(`/${routes.companies}/${id}`);
          setLoading(false);
        }, 1500);
      })
      .catch((e) => {
        openNotification({
          description: parseErrorMessage(e),
          type: NOTIFICATION_TYPE_ENUM.ERROR,
        });
        setLoading(false);
      });
  };

  return (
    <Flex vertical>
      <Typography.Title>Добавить новую компанию</Typography.Title>
      <CompanyForm
        form={form}
        onFinish={saveCompany}
        closeHandler={closeResultModal}
        disabled={loading}
        hideStatementBlock
        initValues={{
          isControlPersonsRF: true,
          isOnlyTaxResidentRF: true,
          isForeignOrg: false,
          isResident: true,
        }}
      />
    </Flex>
  );
};
